import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  AfterContentInit,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { CountdownComponent, CountdownGlobalConfig } from 'ngx-countdown';
import { User } from 'src/app/core/models/persons.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { InfosService } from 'src/app/core/services/infos.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardService } from 'ngx-clipboard';
import {
  ChartOptions,
  ChartType,
  ChartDataset,
  ScatterDataPoint,
  ChartData,
  ChartConfiguration,
  Color,
  Chart,
} from 'chart.js';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';
import { WebSocketSubject } from 'rxjs/webSocket';
import { Subscription } from 'rxjs';
import { LoganApiService } from 'src/app/core/services/api.service';
import { LoganApiConfig } from 'src/app/core/models/services.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-infos',
  templateUrl: './infos.component.html',
  styleUrls: ['./infos.component.scss'],
  providers: [{ provide: CountdownGlobalConfig }],
})
export class InfosComponent implements OnInit, OnDestroy, AfterContentInit {
  user: User;
  isUserAdmin = false;
  isUserAll = false;
  isProd = environment.production;
  currentPage: any;
  private socket$: WebSocketSubject<any> | undefined;
  private subscription: Subscription | undefined;
  logProcessAuto: string[] = [];
  logProcessAutoText: string = '';
  logProcessAutoLimit: number = 100;
  logProcessAutoFilter: string = '';
  logProcessAutoIsPause: boolean = false;
  //logProcessAutoInfoAux1 =
  //   '{"info": [{"group": "2087 - Solicita ConfiguraY00e7Y00f5es", "status": "INICIADO", "states": ["CONCLUIDO", "PENDENTE"], "statesQtd": [1, 26], "steps": [{"id": 1, "group": 2087, "step": 1, "name": "Setar Odometro como 1000", "description": "Solicita ConfiguraY00e7Y00f5es", "type": "COMANDO", "analyticPositionIfHasEvent": false,  "valueTypeExpect": null, "valueExpect": null, "event": null, "eventException": null, "field": null, "logic": null, "commandTypeId": 13, "commandParam": null, "commandTimeOut": null, "createdDateTime": "2023-08-17 17:42:17", "userCreatedId": 18, "status": "INICIADO", "updateStatusDateTime": "2023-08-17 14:48:00.018460"}, {"id": 2, "group": 2087, "step": 2, "name": "Setar Odometro como 1000", "description": "Setar Odometro como 1000", "type": "COMANDO", "analyticPositionIfHasEvent": false, "valueTypeExpect": null, "valueExpect": null, "event": null, "eventException": null, "field": null, "logic": null, "commandTypeId": 21, "commandParam": "1000", "commandTimeOut": "1000", "createdDateTime": "2023-08-17 17:42:17", "userCreatedId": 18, "status": "INICIADO", "updateStatusDateTime": "2023-08-17 14:48:00.019107"}], "infoItemSteps": [26, 0], "lastPositionMoreThanSevenDays": 24, "isDoneQtd": 1, "total": 27}, {"group": "2088 - Solicita ConfiguraY00e7Y00f5es", "status": "INICIADO", "states": ["PENDENTE", "CONCLUIDO", "ENVIANDO"], "statesQtd": [114, 129, 44], "steps": [{"id": 3, "group": 2088, "step": 1, "name": "Setar Odometro como 1000 - GV", "description": "Solicita ConfiguraY00e7Y00f5es", "type": "COMANDO", "analyticPositionIfHasEvent": false, "valueTypeExpect": null, "valueExpect": null, "event": null, "eventException": null, "field": null, "logic": null, "commandTypeId": 13, "commandParam": null, "commandTimeOut": null, "createdDateTime": "2023-08-17 17:42:17", "userCreatedId": 18, "status": "INICIADO", "updateStatusDateTime": "2023-08-17 14:48:00.019606"}, {"id": 4, "group": 2088, "step": 2, "name": "Setar Odometro como 1000 - GV", "description": "Envia comando para habilitar o odometro", "type": "COMANDO", "analyticPositionIfHasEvent": false, "valueTypeExpect": null, "valueExpect": null, "event": null, "eventException": null, "field": null, "logic": null, "commandTypeId": 1, "commandParam": "AT+GTCFG=gv620mg,,,1,,,,,,,,,,,,,,,,,,,,,,,,,,,,,FFFF$", "commandTimeOut": "AT+GTCFG=gv620mg,,,1,,,,,,,,,,,,,,,,,,,,,,,,,,,,,FFFF$", "createdDateTime": "2023-08-17 17:42:18", "userCreatedId": 18, "status": "INICIADO", "updateStatusDateTime": "2023-08-17 14:48:00.019606"}, {"id": 5, "group": 2088, "step": 3, "name": "Setar Odometro como 1000 - GV", "description": "Setar Odometro como 1000", "type": "COMANDO", "analyticPositionIfHasEvent": false, "valueTypeExpect": null, "valueExpect": null, "event": null, "eventException": null, "field": null, "logic": null, "commandTypeId": 21, "commandParam": "1000", "commandTimeOut": "1000", "createdDateTime": "2023-08-17 17:42:18", "userCreatedId": 18, "status": "INICIADO", "updateStatusDateTime": "2023-08-17 14:48:00.019606"}, {"id": 6, "group": 2088, "step": 4, "name": "Setar Odometro como 1000 - GV", "description": "Solicita ConfiguraY00e7Y00f5es", "type": "COMANDO", "analyticPositionIfHasEvent": false, "valueTypeExpect": null, "valueExpect": null, "event": null, "eventException": null, "field": null, "logic": null, "commandTypeId": 13, "commandParam": null, "commandTimeOut": null, "createdDateTime": "2023-08-17 17:42:18", "userCreatedId": 18, "status": "INICIADO", "updateStatusDateTime": "2023-08-17 14:48:00.019606"}], "infoItemSteps": [7, 12, 70, 69], "lastPositionMoreThanSevenDays": 4, "isDoneQtd": 129, "total": 287}]}';
  logProcessAutoInfo: any;
  logProcessInternal = 'Aguarde';

  constructor(
    private infosService: InfosService,
    public toastService: ToastService,
    private authService: AuthService,
    private modalService: NgbModal,
    private _clipboardService: ClipboardService,
    private sanitizer: DomSanitizer
  ) {
    this.user = this.authService.currentUserValue;
    this.isUserAdmin = this.authService.isUserAdmin;
    this.isUserAll = this.authService.isUserAll;
    //this.logProcessAutoInfo = JSON.parse(this.logProcessAutoInfoAux1);
  }
  ngAfterContentInit(): void {
    let url = environment.loganConfig.url + '/rdash';
    url = url.replace('api-', '');
    this.urlRdash = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  urlRdash: SafeResourceUrl | undefined;

  gatewayStatus: string = 'yellow';
  gateways: gateway[] = [];
  refreashTime: number = 15000;
  timeToRefreash: number = this.refreashTime / 1000;
  baseHealth: any = undefined;
  baseHealthGSMTableIndex: any = 0;
  baseHealthA40B: any = undefined;
  baseMEGAHealth: any = undefined;
  chartMEGA: ChartConfiguration[] = [];
  newsletter: any = undefined;
  sqlCode: string = '';
  installationPhotoImage: string = '';

  chartLineGSMAmountItems: number[] = [60, 60];

  newsletterformat: boolean = false;

  products: any = undefined;
  productsSelectAux: string[] = [];
  productSelect: string[] = ['Todos'];
  // Charts

  chartA40BPosition: ChartConfiguration = {
    type: 'line',
    data: { datasets: [] },
  };
  chartGSMPosition: ChartConfiguration = {
    type: 'line',
    data: { datasets: [] },
  };

  data: ChartDataset[] = [];
  dataset: ChartDataset[] = this.data;
  scatterChart: ChartType = 'scatter';
  config: ChartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: '[A40B] - Bateria (V) x Dias instalados',
      },
      legend: {
        display: false,
      },
    },
  };

  openURLGateway(url: string) {
    window.open(`http://${url}:8880`, '_blank');
  }

  openZabbix(enviroment: string) {
    if (enviroment == '0') {
      window.open(
        'http://10.115.187.191:8080/zabbix.php?action=dashboard.view'
      );
    } else if (enviroment == '2') {
      window.open(
        'http://10.115.114.189:8080/zabbix.php?action=dashboard.view'
      );
    }
  }
  openModalInfo(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  public topBarInfo() {
    this.getGateway();
    return this.gatewayStatus;
  }

  ngOnInit(): void {
    if (this.isProd) {
      this.getBaseHealth();
      this.getBaseMEGAHealth();
      this.getBaseHealthA40B();
      this.getNewsletter();
    }
    this.getGateway();
    this.searchWorkerCommandsAuto();
  }
  ngOnDestroy(): void {
    this.processAutoSocketDestroy();
  }

  tabChange(event: any) {
    if (event.nextId === 6) {
      this.onTabEnter();
    }
  }

  logPause() {
    this.logProcessAutoIsPause = !this.logProcessAutoIsPause;
  }

  returnLogProgress(item: any, index: number) {
    let total = Number(item.total);
    let isDoneQtd = Number(item.isDoneQtd);
    let percentFixed = ((isDoneQtd * 100) / total).toFixed(1);
    let element = document.getElementById(`progress-bar-process${index}`);
    if (element != null) {
      element.style.width = `${percentFixed}%`;
      element.ariaValueNow = Number(percentFixed).toFixed(0);
    }
    return percentFixed;
  }
  filterLogProcess() {
    if (this.logProcessAutoFilter != '') {
      let logProcessAutoAux: string[] = this.logProcessAuto.filter(
        (itemFilter: string) => {
          return itemFilter
            .toLocaleLowerCase()
            .includes(this.logProcessAutoFilter.toLocaleLowerCase());
        }
      );
      this.logProcessAutoText = logProcessAutoAux.join('\r\n');
    } else {
      this.logProcessAutoText = this.logProcessAuto.join('\r\n');
    }
  }
  onTabEnter() {
    this.processAutoSocketDestroy();
    this.logProcessInternal = 'Conectando';
    this.socket$ = new WebSocketSubject(
      environment.loganConfig.websocktprocessauto
    );

    this.subscription = this.socket$.subscribe(
      (message: any) => {
        let messageKeys: string[] = Object.keys(message);
        if (messageKeys.includes('info')) {
          this.logProcessAutoInfo = message;
        } else {
          message = JSON.stringify(message);
          if (this.logProcessAutoIsPause) {
            this.logProcessAuto[this.logProcessAuto.length - 1] = message;
          } else {
            if (this.logProcessAuto.length > this.logProcessAutoLimit) {
              this.logProcessAuto.reverse().pop();
              this.logProcessAuto.push(message);
            } else {
              this.logProcessAuto.push(message);
            }
            if (this.logProcessAutoFilter != '') {
              let logProcessAutoAux: string[] = this.logProcessAuto.filter(
                (itemFilter: string) => {
                  return itemFilter
                    .toLocaleLowerCase()
                    .includes(this.logProcessAutoFilter);
                }
              );
              this.logProcessAutoText = logProcessAutoAux.join('\r\n');
            } else {
              this.logProcessAutoText = this.logProcessAuto.join('\r\n');
            }
          }
        }
      },
      (error) => {
        this.logProcessInternal = 'Erro';
      },
      () => {
        this.logProcessInternal = 'Conexão fechada';
        if (this.logProcessAuto.length > this.logProcessAutoLimit) {
          let message = 'Conexão fechada';
          this.logProcessAuto.reverse().pop();
          this.logProcessAuto.push(message);
        }
      }
    );

    if (this.socket$) {
      this.socket$.next('Conectado');
      this.logProcessInternal = 'Conectado';
    }
  }

  processAutoSocketDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.logProcessInternal = 'Desconectado';
    }
    if (this.socket$) {
      this.socket$.complete();
    }
  }

  //

  returniconStatus(date: string) {
    let diffMs =
      new Date().getTime() - (new Date(Number(date)).getTime() - 60000);

    let diffMins = Math.round(diffMs / 60000);
    if (diffMins >= 60) {
      return 'error';
    } else if (diffMins >= 30) {
      return 'warning';
    } else {
      return 'ok';
    }
  }

  returnStatusGeneralGateway(gateway: gateway[]) {
    let statusOk = gateway.filter((item: any) => {
      return item.iconStatus == 'ok';
    });
    let statusWarning = gateway.filter((item: any) => {
      return item.iconStatus == 'warning';
    });
    let statusError = gateway.filter((item: any) => {
      return item.iconStatus == 'error';
    });

    if (
      statusOk.length > 0 &&
      statusError.length < 1 &&
      statusWarning.length < 1
    ) {
      return 'green';
    } else if (
      statusOk.length < 1 &&
      statusError.length > 0 &&
      statusWarning.length < 1
    ) {
      return 'red';
    } else {
      return 'yellow';
    }
  }

  getGateway() {
    this.gateways = [];
    this.infosService.getGateways().subscribe(
      (response: any) => {
        if (response != null) {
          Object.entries(response).forEach((item: any) => {
            item[1].forEach((gateway: gateway) => {
              var datetime = `${new Date(
                Number(gateway.datahora)
              ).toLocaleDateString()} ${
                new Date(Number(gateway.datahora)).getUTCHours() - 3
              }:${new Date(Number(gateway.datahora)).getMinutes()}:${new Date(
                Number(gateway.datahora)
              ).getSeconds()}`;
              gateway.iconStatus = this.returniconStatus(gateway.datahora);
              gateway.datahora = datetime;
              this.gateways.push(gateway);
              this.gatewayStatus = this.returnStatusGeneralGateway(item[1]);
            });
          });
        }
      },
      (error: HttpErrorResponse) => {
        //alert(error.message);
        this.toastService.show('Erro ao pesquisar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  getBaseMEGAHealth() {
    this.infosService.getBaseMEGAHealth().subscribe(
      (response: any) => {
        if (response != null) {
          this.baseMEGAHealth = response;
          if (Object.keys(this.baseMEGAHealth).includes('classDevice')) {
            this.products = this.baseMEGAHealth.classDevice;
            this.productsSelectAux = ['Todos'];
            this.baseMEGAHealth.classDevice.product.forEach(
              (productItem: string) => {
                var productItemAux = productItem.split(',');
                productItemAux.forEach((productItemAuxItem: string) => {
                  var productAux = productItemAuxItem.split('|');
                  if (!this.productsSelectAux.includes(productAux[0])) {
                    this.productsSelectAux.push(productAux[0]);
                  }
                });
              }
            );
          }
          this.chartMEGA.push(
            this.getChartBar(
              this.baseMEGAHealth.osOpen.model,
              'OS por modelo de veículo'
            )
          );
          this.chartMEGA.push(
            this.getChartBar(
              this.baseMEGAHealth.osOpen.contract,
              'OS por contrato'
            )
          );
          this.chartMEGA.push(
            this.getChartBar(
              this.baseMEGAHealth.osOpen.product,
              'OS por produto'
            )
          );
        }
      },
      (error: HttpErrorResponse) => {
        //alert(error.message);
        this.toastService.show(
          'Erro ao carregar informações da base - ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
      }
    );
  }
  getNewsletter() {
    this.infosService.getNewsletter().subscribe((response: any) => {
      if (response != null) {
        this.newsletter = response;
      }
    });
  }

  mounthGraphBaseHealthA40B() {
    let data1: number[][] = [[], [], [], [], []];
    let labels: string[] = [];

    for (
      let index = 0;
      index < this.baseHealthA40B.charts.a40bHistrogramPosition.length;
      index++
    ) {
      if (
        index >
        this.baseHealthA40B.charts.a40bHistrogramPosition.length -
          this.chartLineGSMAmountItems[1]
      ) {
        const element =
          this.baseHealthA40B.charts.a40bHistrogramPosition[index];

        this.data.push({
          type: 'scatter',
          data: [
            {
              x: this.baseHealthA40B.charts.a40bBatteryXInstalledDays
                .installedDays[index],
              y: this.baseHealthA40B.charts.a40bBatteryXInstalledDays.battery[
                index
              ],
            },
          ],
          label:
            this.baseHealthA40B.charts.a40bBatteryXInstalledDays.seriais[index],
          datalabels: { display: 'auto' },
        });
        data1[0].push(element.withoutPosition ?? undefined);
        data1[1].push(element.betweenOneAndFour ?? undefined);
        data1[2].push(element.betweenFourAndFifteen ?? undefined);
        data1[3].push(element.greaterThenFifteen ?? undefined);
        data1[4].push(element.totalDevices ?? undefined);
        labels.push(element.date ?? '');
      }
    }

    let data2: ChartDataset[] = [
      {
        type: 'line',
        data: data1[0],
        label: `Sem posição | ${Math.round(
          (data1[0][data1[0].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
        //        borderColor: 'rgb(220,18,18,1)',
        // backgroundColor: 'rgb(220,18,18,1)',
        // segment: {
        //   borderColor: 'rgb(220,18,18,1)',
        //   backgroundColor: 'rgb(220,18,18,1)',
        // },
        //       fill: false,
      },
      {
        type: 'line',
        data: data1[1],
        label: `>= 0 e <4 | ${Math.round(
          (data1[1][data1[0].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
        //    borderColor: 'rgb(14,96,0,1)',
        // backgroundColor: 'rgb(14,96,0,1)',
        // segment: {
        //   borderColor: 'rgb(14,96,0,1)',
        //   backgroundColor: 'rgb(14,96,0,1)',
        // },
        //    fill: false,
      },
      {
        type: 'line',
        data: data1[2],
        label: `>= 4 < 16 | ${Math.round(
          (data1[2][data1[0].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
        //   borderColor: 'rgb(141,163,10,1)',
        // backgroundColor: 'rgb(141,163,10,1)',
        // segment: {
        //   borderColor: 'rgb(141,163,10,1)',
        //   backgroundColor: 'rgb(141,163,10,1)',
        // },
        //  fill: false,
      },
      {
        type: 'line',
        data: data1[3],
        label: `>= 16 | ${Math.round(
          (data1[3][data1[0].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
        //      borderColor: 'rgb(99,23,176,1)',
        // backgroundColor: 'rgb(99,23,176,1)',
        // segment: {
        //   borderColor: 'rgb(99,23,176,1)',
        //   backgroundColor: 'rgb(99,23,176,1)',
        // },
        //  fill: false,
      },
      {
        type: 'line',
        data: data1[4],
        label: 'Dispositivos instalados',
        //      borderColor: 'rgb(22,18,220,1)',
        // backgroundColor: 'rgb(22,18,220,1)',
        // segment: {
        //   borderColor: 'rgb(22,18,220,1)',
        //   backgroundColor: 'rgb(22,18,220,1)',
        // },
        //      fill: false,
      },
    ];
    let config: ChartOptions = {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: '[A40B] - Dias sem posicao',
        },
        legend: {
          display: true,
        },
      },
    };
    this.chartA40BPosition.options = config;
    this.chartA40BPosition.data = {
      labels: labels,
      datasets: data2,
    };
  }
  mounthGraphBaseHealthGSM() {
    this.baseHealthGSMTableIndex =
      this.baseHealth.charts.GSMHistrogramPosition.length - 1;

    let data1: number[][] = [[], [], [], [], []];
    let labels: string[] = [];
    for (
      let index = 0;
      index < this.baseHealth.charts.GSMHistrogramPosition.length;
      index++
    ) {
      const element = this.baseHealth.charts.GSMHistrogramPosition[index];
      if (
        index >
        this.baseHealth.charts.GSMHistrogramPosition.length -
          this.chartLineGSMAmountItems[0]
      ) {
        data1[0].push(element.withoutPosition.qtd ?? undefined);
        data1[1].push(element.betweenOneAndFour.qtd ?? undefined);
        data1[2].push(element.betweenFourAndFifteen.qtd ?? undefined);
        data1[3].push(element.greaterThenFifteen.qtd ?? undefined);
        data1[4].push(element.totalDevices ?? undefined);
        labels.push(element.date ?? '');
      }
    }

    let data2: ChartDataset[] = [
      {
        type: 'line',
        data: data1[0],
        label: `Sem posição | ${Math.round(
          (data1[0][data1[0].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
      },
      {
        type: 'line',
        data: data1[1],
        label: `>= 0 e <4 | ${Math.round(
          (data1[1][data1[1].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
      },
      {
        type: 'line',
        data: data1[2],
        label: `>= 4 < 16 | ${Math.round(
          (data1[2][data1[2].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
      },
      {
        type: 'line',
        data: data1[3],
        label: `>= 16 | ${Math.round(
          (data1[3][data1[3].length - 1] * 100) / data1[4][data1[4].length - 1]
        )}%`,
      },
      {
        type: 'line',
        data: data1[4],
        label: 'Dispositivos instalados',
      },
    ];
    let config: ChartOptions = {
      responsive: true,
      plugins: {
        tooltip: {
          callbacks: {
            label: function (context: any) {
              let datasetLabel = context.dataset.label || '';
              let value = context.dataset.data[context.dataIndex];
              let totalDevices = data1[4][context.dataIndex];
              let percentage = Math.round((value * 100) / totalDevices);
              return `${datasetLabel}: ${value} (${percentage}%)`;
            },
          },
        },
        title: {
          display: true,
          text: '[GSM] - Dias sem posicao',
        },
        legend: {
          display: true,
        },
      },
    };
    this.chartGSMPosition.options = config;
    this.chartGSMPosition.data = {
      labels: labels,
      datasets: data2,
    };
  }

  getBaseHealth() {
    this.infosService.getBaseHealth().subscribe(
      (response: any) => {
        if (response != null) {
          if (response != null) {
            this.baseHealth = response;
            if (this.baseHealth.charts.GSMHistrogramPosition.length > 0) {
              this.mounthGraphBaseHealthGSM();
            }
          }
        }
      },
      (error: HttpErrorResponse) => {
        //alert(error.message);
        this.toastService.show(
          'Erro ao carregar informações da base - ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
      }
    );
  }

  getChartA40B() {}

  convertBlobToBase64(imageBlob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result as string;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(imageBlob);
    });
  }

  getBaseHealthA40B() {
    this.infosService.getBaseHealthA40B().subscribe(
      (response: any) => {
        this.data = [];
        if (response != null) {
          this.baseHealthA40B = response;
          if (this.baseHealthA40B.charts.a40bHistrogramPosition.length > 0) {
            this.mounthGraphBaseHealthA40B();
          }
        }
      },
      (error: HttpErrorResponse) => {
        //alert(error.message);
        this.toastService.show(
          'Erro ao carregar informações da base - ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
      }
    );
  }

  getChartBar(item: any[], title: string) {
    let labels: string[] = [];
    let data: ChartDataset[] = [];
    let qtd: any[] = [];
    const keys = item.filter((itemAux, index) => {
      return item.indexOf(itemAux) === index;
    });
    keys.forEach((keyAux: any) => {
      let filter = item.filter((itemAux: any) => {
        return itemAux == keyAux;
      });
      qtd.push(filter.length);
      labels.push(keyAux);
    });
    data.push({
      type: 'bar',
      data: qtd,
    });
    let config: ChartOptions = {
      responsive: true,
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
        },
        title: {
          display: true,
          text: title,
        },
        legend: {
          display: false,
        },
      },
      indexAxis: 'y',
    };

    let chart: ChartConfiguration = {
      type: 'bar',
      data: { datasets: [] },
      plugins: [DataLabelsPlugin],
    };
    chart.options = config;
    chart.plugins = [DataLabelsPlugin];
    chart.data = {
      labels: labels,
      datasets: data,
    };
    return chart;
  }
  copyToClipboardSimple(item: any): void {
    try {
      this._clipboardService.copy(item);
      this.toastService.show('Copiado para a área de transferência', {
        classname: 'bg-success text-center text-white',
        delay: 25000,
      });
    } catch (error: any) {
      this.toastService.show('Erro ao copiar', {
        classname: 'bg-danger text-center text-white',
        delay: 10000,
      });
    }
  }

  copyToClipboard(item: any): void {
    try {
      if (item.sql) {
        item.sql = '';
      }

      let headers: string[] = [];
      let headersNot: string[] = ['currentPage'];
      let keys = Object.keys(item);
      let result = '';
      headers.forEach((itemHeaders) => {
        if (itemHeaders in keys) {
          headers.push(itemHeaders);
        }
      });
      keys.forEach((itemKeys: any) => {
        if (!headers.includes(itemKeys) && !headersNot.includes(itemKeys)) {
          headers.push(itemKeys);
        }
      });

      headers.forEach((itemHeaders: string) => {
        result = result + itemHeaders + '\t';
      });

      for (let index = 0; index < Object(item)[keys[0]].length; index++) {
        result = result + '\n';
        headers.forEach((itemHeaders: string) => {
          result = result + Object(item)[itemHeaders][index] + '\t';
        });
      }

      this._clipboardService.copy(result);
      this.toastService.show('Copiado para a área de transferência', {
        classname: 'bg-success text-center text-white',
        delay: 25000,
      });
    } catch (error: any) {
      this.toastService.show('Erro ao copiar', {
        classname: 'bg-danger text-center text-white',
        delay: 10000,
      });
    }
  }

  changeIndexGSMTable(value: number) {
    this.baseHealthGSMTableIndex = this.baseHealthGSMTableIndex + value;
    if (
      this.baseHealthGSMTableIndex >
      this.baseHealth.charts.GSMHistrogramPosition.length - 1
    ) {
      this.baseHealthGSMTableIndex = 0;
    } else if (this.baseHealthGSMTableIndex < 0) {
      this.baseHealthGSMTableIndex =
        this.baseHealth.charts.GSMHistrogramPosition.length - 1;
    }
  }

  hasKey(item: any, key: string) {
    return Object.keys(item).includes(key);
  }

  getIndex(lst: any[], item: any) {
    try {
      return lst.findIndex((itemSerial: string) => {
        return itemSerial == item;
      });
    } catch {
      return '';
    }
  }

  getProductFilter(filter: string[]) {
    this.products = this.baseMEGAHealth.classDevice;
    if (this.productSelect.length == 0) {
      this.productSelect = ['Todos'];
    }
    if (
      this.productSelect.length > 1 ||
      (this.productSelect.length == 1 && this.productSelect[0] != 'Todos')
    ) {
      this.productSelect = this.productSelect.filter((item: any) => {
        return item != 'Todos';
      });
      var productAux: any = {
        attributes: [],
        class: [],
        model: [],
        currentePage: 1,
        product: [],
        sql: this.products.sql,
      };
      for (let index = 0; index < this.products.class.length; index++) {
        let itemSplit = this.products.product[index].split(',');
        var aux = false;
        itemSplit.forEach((itemAux: any) => {
          if (filter.includes(itemAux.split('|')[0])) {
            aux = true;
          }
        });
        if (aux) {
          productAux.attributes.push(this.products.attributes[index]);
          productAux.class.push(this.products.class[index]);
          productAux.model.push(this.products.model[index]);
          productAux.attributes.push(this.products.attributes[index]);
          productAux.product.push(this.products.product[index]);
        }
      }
      this.products = productAux;
    }
  }

  split(item: string) {
    return item.split(',');
  }
  getKeysSub(item: any, keysSub: string[]): string[] {
    let keys: string[] = [];
    Object.keys(item).forEach((key: string) => {
      if (!keysSub.includes(key)) {
        keys.push(key);
      }
    });
    return keys;
  }
  getKeys(item: any): string[] {
    return Object.keys(item) ?? [];
  }
  getValuesList(item: any, key: string) {
    return Object(item)[key];
  }
  transpose(item: any): any[] {
    let result: string[] = [];
    let size: number = 0;
    Object.keys(item).forEach((key: string) => {
      if (item[key].length > size) {
        size = item[key].length;
      }
    });
    for (let index = 0; index < size; index++) {
      let row: any = [];
      Object.keys(item).forEach((key: string) => {
        if (item[key][index]) {
          row.push(item[key][index]);
        } else {
          row.push(JSON.parse('{"serial":"", "qtd":""}'));
        }
      });
      result.push(row);
    }
    return result;
  }
  openMegaOS(url: string) {
    window.open(url);
  }

  openInfoSQL(centerDataModal: any, sqlCode: string) {
    this.sqlCode = sqlCode;
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }
  openModelImage(centerDataModal: any, image: string) {
    this.installationPhotoImage = image;
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  searchWorkerCommandsAuto() {
    this.infosService.getWorkerCommandsAuto().subscribe(
      (response : any) => {
        if(response.worker_auto) {
          response.worker_auto.forEach((item : commands) => {
                let tipoComando = Number(item.comando);
                if(tipoComando == 15) {item.comando = 'CONF_TEMPO_POS_MOVENDO_E_PARADO'}
                if(item.mensagem.includes(item.serial)){
                  var msg = item.mensagem.split(item.serial + " ");
                  item.mensagem = msg[1];
                } 
                if(item.param.includes(";")) {let split = item.param.split(";"); item.param = split[0] + "/" + split[1]}
                if(item.statusComando == '1'){this.commandSuccess++; item.statusComando = "Agendado"};
                if(item.statusComando == '4'){this.commandError++; item.statusComando = "Erro ao Agendar"};
                let dateMilli = Number(item.requestDate);
                item.requestDate = this.formatTimestamp(dateMilli, 3); //minus 3
                this.comandos.push(item);
              });  
            this.updateChartData() 
          }
          if(response.commands_worker_auto) {
            response.commands_worker_auto.forEach((item : commands) => {              
              let statusComando = Number(item.statusComando);
              if(statusComando == 1) {item.statusComando = "Agendado", this.commandAgendado++}
              if(statusComando == 2) {item.statusComando = "Enviado", this.commandEnviado++}
              if(statusComando == 3) {item.statusComando = "Executado", this.commandExecutado++}
              if(statusComando == 4) {item.statusComando = "Cancelado", this.commandCancelado++}
              if(statusComando == 5) {item.statusComando = "Expirado", this.commandExpirado++}
              if(statusComando == 6) {item.statusComando = "Erro", this.commandErr++}
              let tipoComando = Number(item.comando)
              if(tipoComando == 15) {item.comando = 'CONF_TEMPO_POS_MOVENDO_E_PARADO'}
              let dateMilli = Number(item.requestDate);
              item.requestDate = this.formatTimestamp(dateMilli, 0);
              if(item.mensagem == null || item.mensagem == undefined || item.mensagem == '') {item.mensagem = '-'}
              if(item.param.includes(";")) {let split = item.param.split(";"); item.param = split[0] + "/" + split[1]}
              this.comandoStatus.push(item);
            });  
            this.updateChartDataAuto()  
          }
          if(response.commands_expired_mega || response.commands_error_mega) {
              response.commands_expired_mega.forEach((item : commands) => {              
                let statusComando = Number(item.statusComando);
                if(statusComando == 5) {item.statusComando = "Comando Expirado", this.commandMEGAExpirado++}
                if(statusComando == 6) {item.statusComando = "Comando com Erro", this.commandMEGAErr++}
                let tipoComando = Number(item.comando)
                if(tipoComando == 15) {item.comando = 'CONF_TEMPO_POS_MOVENDO_E_PARADO'}
                if(item.mensagem == null || item.mensagem == undefined || item.mensagem == '') {item.mensagem = '-'}
                let dateMilli = Number(item.requestDate);
                item.requestDate = this.formatTimestamp(dateMilli, 0);
                if(item.param.includes(";")) {let split = item.param.split(";"); item.param = split[0] + "/" + split[1]}
                this.comandoMega.push(item);
              });
              response.commands_error_mega.forEach((item : commands) => {              
                let statusComando = Number(item.statusComando);
                if(statusComando == 5) {item.statusComando = "Comando Expirado", this.commandMEGAExpirado++}
                if(statusComando == 6) {item.statusComando = "Comando com Erro", this.commandMEGAErr++}
                let tipoComando = Number(item.comando)
                if(tipoComando == 15) {item.comando = 'CONF_TEMPO_POS_MOVENDO_E_PARADO'}
                if(item.mensagem == null || item.mensagem == undefined || item.mensagem == '') {item.mensagem = '-'}
                let dateMilli = Number(item.requestDate);
                item.requestDate = this.formatTimestamp(dateMilli, 0);
                if(item.param.includes(";")) {let split = item.param.split(";"); item.param = split[0] + "/" + split[1]}
                this.comandoMega.push(item);
              }); 
            this.updateChartDataMEGA()  
          }   
        }
    ), (error: HttpErrorResponse) => {
        //alert(error.message);
        this.toastService.show('Erro ao pesquisar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }    
  }

  // Comandos Worker
  comandos : commands []  = [] ;
  commandError : number = 0;
  commandSuccess : number = 0;
 
  pieChartType: 'pie' = 'pie';
  pieChartData: ChartData<'pie', number[], string> = {
    labels: ['Erro ao Agendar Comando', 'Comando Agendado'],
    datasets: [
      {
        data: [this.commandSuccess, this.commandError],
        backgroundColor: ['#eb3636ff' , '#fff563ff'],
      },
    ],
  };
  pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (value) => value,
      },
    },
  };
  pieChartPlugins = [DataLabelsPlugin];

  updateChartData() {
    this.pieChartData.datasets[0].data = [this.commandError, this.commandSuccess];
  }

  ComandosPaginaAtual = 1;
  itensPorPagina = 10;

  get totalPaginas(): number {
    return Math.ceil(this.comandos.length / this.itensPorPagina);
  }
  get dadosPaginados() {
    const inicio = (this.ComandosPaginaAtual - 1) * this.itensPorPagina;
    return this.comandos.slice(inicio, inicio + this.itensPorPagina);
  }
  proximaPagina() {
    if (this.ComandosPaginaAtual < this.totalPaginas) {
      this.ComandosPaginaAtual++;
    }
  }
  paginaAnterior() {
    if (this.ComandosPaginaAtual > 1) {
      this.ComandosPaginaAtual--;
    }
  }
  formatTimestamp(millis: number, minus : number): string {
  const date = new Date(millis);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // Janeiro é 0
  const year = date.getFullYear().toString();
  const hours = pad(date.getHours() - minus);
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

  // Grafico Status Commands Worker Auto
  comandoStatus : commands []  = [] ;
  commandAgendado : number = 0; 
  commandEnviado : number = 0; 
  commandExecutado : number = 0; 
  commandCancelado : number = 0; 
  commandExpirado : number = 0; 
  commandErr : number = 0;  
  pieChartTypeAuto: 'pie' = 'pie';
  pieChartDataAuto: ChartData<'pie', number[], string> = {
    labels: ['Comandos Agendados', 'Comandos Enviados', 'Comandos Executados', 'Comandos Cancelados', 'Comandos Expirados', 'Comandos com Erro'],
    datasets: [
      {
        data: [this.commandAgendado, this.commandEnviado, this.commandExecutado, this.commandCancelado, this.commandExpirado, this.commandErr],
        backgroundColor: ['#fff563ff', '#36e8ebff', '#36eb4bff', '#eb9736ff', '#364eebff', '#eb3636ff'],
      },
    ],
  };
  pieChartOptionsAuto: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (value) => value,
      },
    },
  };
  pieChartPluginsAuto = [DataLabelsPlugin];

  updateChartDataAuto() {
    this.pieChartDataAuto.datasets[0].data = [this.commandAgendado, this.commandEnviado, this.commandExecutado, this.commandCancelado, this.commandExpirado, this.commandErr];
  }

  ComandosPaginaAtualAuto = 1;
  itensPorPaginaAuto = 10;

  get totalPaginasAuto(): number {
    return Math.ceil(this.comandoStatus.length / this.itensPorPaginaAuto);
  }
  get dadosPaginadosAuto() {
    const inicio = (this.ComandosPaginaAtualAuto - 1) * this.itensPorPaginaAuto;
    return this.comandos.slice(inicio, inicio + this.itensPorPaginaAuto);
  }
  proximaPaginaAuto() {
    if (this.ComandosPaginaAtualAuto < this.totalPaginasAuto) {
      this.ComandosPaginaAtualAuto++;
    }
  }
  paginaAnteriorAuto() {
    if (this.ComandosPaginaAtualAuto > 1) {
      this.ComandosPaginaAtualAuto--;
    }
  }

  // Grafico comandos MEGA
  comandoMega : commands []  = [] ;
  commandMEGAExpirado : number = 0; 
  commandMEGAErr : number = 0;
  pieChartTypeMEGA: 'pie' = 'pie';
  pieChartDataMEGA: ChartData<'pie', number[], string> = {
    labels: ['Comandos Expirados', 'Comandos com Erro'],
    datasets: [
      {
        data: [this.commandMEGAErr, this.commandMEGAExpirado],
        backgroundColor: ['#364eebff', '#eb3636ff'],
      },
    ],
  };
  pieChartOptionsMEGA: ChartOptions<'pie'> = {
    responsive: true,
    plugins: {
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (value) => value,
      },
    },
  };
  pieChartPluginsMEGA = [DataLabelsPlugin];

  updateChartDataMEGA() {
    this.pieChartDataMEGA.datasets[0].data = [this.commandMEGAExpirado, this.commandMEGAErr];
  }

  ComandosPaginaAtualMEGA = 1;
  itensPorPaginaMEGA = 10;

  get totalPaginasMEGA(): number {
    return Math.ceil(this.comandoMega.length / this.itensPorPaginaMEGA);
  }
  get dadosPaginadosMEGA() {
    const inicio = (this.ComandosPaginaAtualMEGA - 1) * this.itensPorPaginaMEGA;
    return this.comandoMega.slice(inicio, inicio + this.itensPorPaginaMEGA);
  }
  proximaPaginaMEGA() {
    if (this.ComandosPaginaAtualMEGA < this.totalPaginasMEGA) {
      this.ComandosPaginaAtualMEGA++;
    }
  }
  paginaAnteriorMEGA() {
    if (this.ComandosPaginaAtualMEGA > 1) {
      this.ComandosPaginaAtualMEGA--;
    }
  }

  exportToCSV(data: commands[], fileName: string) {
    const columns = [
      'serial',
      'sistema',
      'mensagem',
      'requestDate',
      'comando',
      'param',
      'statusComando'
    ];
    const header = columns.join(';');
    const rows = data.map(obj =>
      columns.map(col => (obj as any)[col]).join(';')
    );
    // Monta CSV
    const csvContent = [header, ...rows].join('\n');
    // Download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', fileName + '.csv');
    link.click();
  }

}
export class commands {
  serial: string;
  sistema: string;
  mensagem: string;
  requestDate: string;
  comando: string;
  param: string;
  statusComando : string;
  constructor() {
    this.serial = '';
    this.sistema = '';
    this.mensagem = '';
    this.requestDate = '';
    this.comando = '';
    this.param = '';
    this.statusComando = '';
  }
}
export class gateway {
  ip: string;
  datahora: string;
  devices: number;
  iconStatus: string;
  constructor() {
    this.ip = '';
    this.datahora = '';
    this.devices = 0;
    this.iconStatus = '';
  }
}
